// extracted by mini-css-extract-plugin
module.exports = {"reviewPostBanner":"review-post-banner-module--review-post-banner--3CvQS"};